var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-button",
        {
          staticClass: "filter-item",
          staticStyle: { "margin-bottom": "10px" },
          attrs: { type: "success", icon: "el-icon-back" },
          on: { click: _vm.onClickReturn }
        },
        [_vm._v("返回")]
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.taskInfo.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "10px" } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("span", { staticClass: "desc" }, [
                          _vm._v(
                            "升级版本号：" +
                              _vm._s(_vm.taskInfo.versionInfoName)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("span", { staticClass: "desc" }, [
                          _vm._v(
                            "所属设备型号：" +
                              _vm._s(_vm.taskInfo.deviceTypeCode)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("span", { staticClass: "desc" }, [
                          _vm._v("升级模块：" + _vm._s(_vm.moduleLabel))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "padding-top": "10px" } }, [
                    _c("span", { staticClass: "desc" }, [
                      _vm._v("备注：" + _vm._s(_vm.taskInfo.description))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "col-title" }, [
                          _vm._v("升级中")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-val" }, [
                          _vm._v(_vm._s(_vm.taskInfo.upgrading))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "col-title" }, [
                          _vm._v("升级成功")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-val" }, [
                          _vm._v(_vm._s(_vm.taskInfo.success))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "col-title" }, [
                          _vm._v("升级失败")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-val" }, [
                          _vm._v(_vm._s(_vm.taskInfo.fail))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.taskInfo.taskList,
            border: "",
            stripe: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  prop: item.prop,
                  label: item.label,
                  formatter: item.formatter
                }
              })
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }